import React, { Component } from "react";
import Api from "../Components/Api.js";

export default class TelemonitoringHospital extends Component {
  state = {
    amount: 0,
    loadingApi: true
  };

  componentDidMount() {
    this.init();
  }

  async init() {
    var _result = await Api.dietzdashboard('TelemonitoringHospital');

    this.setState({amount: _result.data.amount, loadingApi: false});
  }

  render() {
    return (
      <div className="dd-card-small dd-card-small-blue dd-shadow">
        <div className="uk-grid uk-flex-middle">
          <div className="uk-width-expand">
            <div className="dd-card-small-title uk-text-uppercase">Hospital/Clinics</div>
            {
              this.state.loadingApi === true ? 
              <div><span uk-spinner=""></span></div>
              :
              <div className="dd-card-small-text">{this.state.amount}</div>
            }
          </div>
          <div className="uk-width-auto">
            <i className="fas fa-hospital dd-card-small-icon"></i>
          </div>
        </div>
      </div>
    );
  }
}
